import React from 'react';
import { Link } from 'react-router-dom';
import PublicSiteShell from '../components/public/PublicSiteShell';

export default function TerminosServicio() {
  return (
    <PublicSiteShell hideFooterCta={true}>
      <div className="gst-site">
        <div className="gst-container py-16">
          <div className="mx-auto max-w-3xl overflow-hidden rounded-[2rem] border border-[var(--gst-border)] bg-[var(--surface)] p-8 shadow-[0_24px_60px_rgba(31,36,33,0.04)] md:p-12">
            <h1 className="gst-public-display text-4xl font-black text-[var(--gst-graphite-900)] mb-2">Términos de Servicio</h1>
            <p className="text-[var(--gst-mint-700)] font-bold tracking-widest uppercase text-xs mb-8">Última actualización: Marzo 2026</p>

            <div className="space-y-6 text-[var(--gst-graphite-700)] leading-relaxed">
              <h2 className="text-xl font-bold text-[var(--gst-graphite-900)] uppercase tracking-tight">1. Aceptación de los términos</h2>
              <p>
                Al acceder y usar los servicios de Gastify, aceptás estos Términos de Servicio y todas las leyes y regulaciones que apliquen. Si no estás de acuerdo con alguno de estos términos, no podés usar este sitio.
              </p>

              <h2 className="text-xl font-bold text-[var(--gst-graphite-900)] uppercase tracking-tight mt-8">2. Descripción del servicio</h2>
              <p>
                Gastify es un software de gestión comercial (SaaS) que incluye herramientas de facturación, punto de venta, inventario y funciones de inteligencia artificial. Nos reservamos el derecho de modificar o discontinuar el servicio de forma temporal o permanente, con o sin aviso previo.
              </p>

              <h2 className="text-xl font-bold text-[var(--gst-graphite-900)] uppercase tracking-tight mt-8">3. Cuenta de usuario</h2>
              <p>
                Sos responsable de mantener la confidencialidad de tu cuenta y contraseña, y de restringir el acceso a tu computadora. Te hacés responsable por todas las actividades que ocurran con tu cuenta o contraseña.
              </p>

              <h2 className="text-xl font-bold text-[var(--gst-graphite-900)] uppercase tracking-tight mt-8">4. Privacidad y datos</h2>
              <p>
                El uso de Gastify también se rige por nuestra <Link to="/legales/privacidad" className="text-[var(--gst-mint-600)] hover:text-[var(--gst-mint-700)] underline">Política de Privacidad</Link>. Protegemos el contenido alojado con métodos criptográficos estándar y no comercializamos ninguna información ni métrica que cargues en Gastify.
              </p>
            </div>
          </div>
        </div>
      </div>
    </PublicSiteShell>
  );
}
